// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

import {
  SHOW_LOADER
} from '../actions/actions';
import constants from '../Constants';

const initialState = {
  showLoader: false
};

const handlers = {
  [SHOW_LOADER]: (state, action) => {
    return {
      showLoader: action.result
    };
  }

};

export default function statusReducer(state = initialState, action) {
  let handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}



// WEBPACK FOOTER //
// ./src/js/reducers/status.js